import {  Button, Dropdown, Notification, Timeline, Tooltip, toast } from "components/ui";
import { CompanyContext } from "contexts/CompanyContext";
import React, { useContext, useEffect, useRef, useState } from "react";
import { HiCheckCircle, HiChevronDown } from "react-icons/hi2";
import { HiOutlineCheckCircle } from "react-icons/hi2";
import {  HiOutlineArrowUp } from "react-icons/hi";
import { components } from "react-select";
import { particleBackgroundSettingsButton } from "configs/particle-background.config";
import ParticleBackground from 'react-particle-backgrounds'
import { Loading } from "components/shared";
import { useSelector } from "react-redux";
import { useHolidays } from "utils/hooks/useHolidays";
import { useTranslation } from "react-i18next";
import { AIContext } from "contexts/AIContext";
import ConfigPanel from "../ConfigPanel";
import usePostGenerationQuantity from "utils/hooks/usePostGenerationQuantity";
import { BsStars } from "react-icons/bs";
import { TbX } from "react-icons/tb";
import { useWhitelabel } from 'contexts/WhitelabelThemeContext';

const { Control } = components

export const countryOptions = [
    { value: "af", label: "Afghanistan", image: "https://flagcdn.com/h40/af.png" },
    { value: "al", label: "Albania", image: "https://flagcdn.com/h40/al.png" },
    { value: "dz", label: "Algeria", image: "https://flagcdn.com/h40/dz.png" },
    { value: "as", label: "American Samoa", image: "https://flagcdn.com/h40/as.png" },
    { value: "ad", label: "Andorra", image: "https://flagcdn.com/h40/ad.png" },
    { value: "ao", label: "Angola", image: "https://flagcdn.com/h40/ao.png" },
    { value: "ai", label: "Anguilla", image: "https://flagcdn.com/h40/ai.png" },
    { value: "ag", label: "Antigua and Barbuda", image: "https://flagcdn.com/h40/ag.png" },
    { value: "ar", label: "Argentina", image: "https://flagcdn.com/h40/ar.png" },
    { value: "am", label: "Armenia", image: "https://flagcdn.com/h40/am.png" },
    { value: "aw", label: "Aruba", image: "https://flagcdn.com/h40/aw.png" },
    { value: "au", label: "Australia", image: "https://flagcdn.com/h40/au.png" },
    { value: "at", label: "Austria", image: "https://flagcdn.com/h40/at.png" },
    { value: "az", label: "Azerbaijan", image: "https://flagcdn.com/h40/az.png" },
    { value: "bh", label: "Bahrain", image: "https://flagcdn.com/h40/bh.png" },
    { value: "bd", label: "Bangladesh", image: "https://flagcdn.com/h40/bd.png" },
    { value: "bb", label: "Barbados", image: "https://flagcdn.com/h40/bb.png" },
    { value: "by", label: "Belarus", image: "https://flagcdn.com/h40/by.png" },
    { value: "be", label: "Belgium", image: "https://flagcdn.com/h40/be.png" },
    { value: "bz", label: "Belize", image: "https://flagcdn.com/h40/bz.png" },
    { value: "bj", label: "Benin", image: "https://flagcdn.com/h40/bj.png" },
    { value: "bm", label: "Bermuda", image: "https://flagcdn.com/h40/bm.png" },
    { value: "bt", label: "Bhutan", image: "https://flagcdn.com/h40/bt.png" },
    { value: "bo", label: "Bolivia", image: "https://flagcdn.com/h40/bo.png" },
    { value: "ba", label: "Bosnia and Herzegovina", image: "https://flagcdn.com/h40/ba.png" },
    { value: "bw", label: "Botswana", image: "https://flagcdn.com/h40/bw.png" },
    { value: "br", label: "Brazil", image: "https://flagcdn.com/h40/br.png" },
    { value: "vg", label: "British Virgin Islands", image: "https://flagcdn.com/h40/vg.png" },
    { value: "bn", label: "Brunei", image: "https://flagcdn.com/h40/bn.png" },
    { value: "bg", label: "Bulgaria", image: "https://flagcdn.com/h40/bg.png" },
    { value: "bf", label: "Burkina Faso", image: "https://flagcdn.com/h40/bf.png" },
    { value: "bi", label: "Burundi", image: "https://flagcdn.com/h40/bi.png" },
    { value: "cv", label: "Cabo Verde", image: "https://flagcdn.com/h40/cv.png" },
    { value: "kh", label: "Cambodia", image: "https://flagcdn.com/h40/kh.png" },
    { value: "cm", label: "Cameroon", image: "https://flagcdn.com/h40/cm.png" },
    { value: "ca", label: "Canada", image: "https://flagcdn.com/h40/ca.png" },
    { value: "ky", label: "Cayman Islands", image: "https://flagcdn.com/h40/ky.png" },
    { value: "cf", label: "Central African Republic", image: "https://flagcdn.com/h40/cf.png" },
    { value: "cl", label: "Chile", image: "https://flagcdn.com/h40/cl.png" },
    { value: "cn", label: "China", image: "https://flagcdn.com/h40/cn.png" },
    { value: "co", label: "Colombia", image: "https://flagcdn.com/h40/co.png" },
    { value: "km", label: "Comoros", image: "https://flagcdn.com/h40/km.png" },
    { value: "cg", label: "Congo", image: "https://flagcdn.com/h40/cg.png" },
    { value: "cd", label: "Congo Democratic Republic", image: "https://flagcdn.com/h40/cd.png" },
    { value: "ck", label: "Cook Islands", image: "https://flagcdn.com/h40/ck.png" },
    { value: "cr", label: "Costa Rica", image: "https://flagcdn.com/h40/cr.png" },
    { value: "ci", label: "Cote d'Ivoire", image: "https://flagcdn.com/h40/ci.png" },
    { value: "hr", label: "Croatia", image: "https://flagcdn.com/h40/hr.png" },
    { value: "cu", label: "Cuba", image: "https://flagcdn.com/h40/cu.png" },
    { value: "cw", label: "Curaçao", image: "https://flagcdn.com/h40/cw.png" },
    { value: "cy", label: "Cyprus", image: "https://flagcdn.com/h40/cy.png" },
    { value: "cz", label: "Czech Republic", image: "https://flagcdn.com/h40/cz.png" },
    { value: "dk", label: "Denmark", image: "https://flagcdn.com/h40/dk.png" },
    { value: "dj", label: "Djibouti", image: "https://flagcdn.com/h40/dj.png" },
    { value: "dm", label: "Dominica", image: "https://flagcdn.com/h40/dm.png" },
    { value: "do", label: "Dominican Republic", image: "https://flagcdn.com/h40/do.png" },
    { value: "tl", label: "East Timor", image: "https://flagcdn.com/h40/tl.png" },
    { value: "ec", label: "Ecuador", image: "https://flagcdn.com/h40/ec.png" },
    { value: "eg", label: "Egypt", image: "https://flagcdn.com/h40/eg.png" },
    { value: "sv", label: "El Salvador", image: "https://flagcdn.com/h40/sv.png" },
    { value: "gq", label: "Equatorial Guinea", image: "https://flagcdn.com/h40/gq.png" },
    { value: "er", label: "Eritrea", image: "https://flagcdn.com/h40/er.png" },
    { value: "ee", label: "Estonia", image: "https://flagcdn.com/h40/ee.png" },
    { value: "et", label: "Ethiopia", image: "https://flagcdn.com/h40/et.png" },
    { value: "fk", label: "Falkland Islands", image: "https://flagcdn.com/h40/fk.png" },
    { value: "fo", label: "Faroe Islands", image: "https://flagcdn.com/h40/fo.png" },
    { value: "fi", label: "Finland", image: "https://flagcdn.com/h40/fi.png" },
    { value: "fr", label: "France", image: "https://flagcdn.com/h40/fr.png" },
    { value: "pf", label: "French Polynesia", image: "https://flagcdn.com/h40/pf.png" },
    { value: "ga", label: "Gabon", image: "https://flagcdn.com/h40/ga.png" },
    { value: "gm", label: "Gambia", image: "https://flagcdn.com/h40/gm.png" },
    { value: "ge", label: "Georgia", image: "https://flagcdn.com/h40/ge.png" },
    { value: "de", label: "Germany", image: "https://flagcdn.com/h40/de.png" },
    { value: "gh", label: "Ghana", image: "https://flagcdn.com/h40/gh.png" },
    { value: "gi", label: "Gibraltar", image: "https://flagcdn.com/h40/gi.png" },
    { value: "gr", label: "Greece", image: "https://flagcdn.com/h40/gr.png" },
    { value: "gl", label: "Greenland", image: "https://flagcdn.com/h40/gl.png" },
    { value: "gd", label: "Grenada", image: "https://flagcdn.com/h40/gd.png" },
    { value: "gt", label: "Guatemala", image: "https://flagcdn.com/h40/gt.png" },
    { value: "gg", label: "Guernsey", image: "https://flagcdn.com/h40/gg.png" },
    { value: "gn", label: "Guinea", image: "https://flagcdn.com/h40/gn.png" },
    { value: "gw", label: "Guinea-Bissau", image: "https://flagcdn.com/h40/gw.png" },
    { value: "gy", label: "Guyana", image: "https://flagcdn.com/h40/gy.png" },
    { value: "ht", label: "Haiti", image: "https://flagcdn.com/h40/ht.png" },
    { value: "va", label: "Holy See (Vatican City)", image: "https://flagcdn.com/h40/va.png" },
    { value: "hn", label: "Honduras", image: "https://flagcdn.com/h40/hn.png" },
    { value: "hk", label: "Hong Kong", image: "https://flagcdn.com/h40/hk.png" },
    { value: "hu", label: "Hungary", image: "https://flagcdn.com/h40/hu.png" },
    { value: "is", label: "Iceland", image: "https://flagcdn.com/h40/is.png" },
    { value: "in", label: "India", image: "https://flagcdn.com/h40/in.png" },
    { value: "id", label: "Indonesia", image: "https://flagcdn.com/h40/id.png" },
    { value: "ir", label: "Iran", image: "https://flagcdn.com/h40/ir.png" },
    { value: "iq", label: "Iraq", image: "https://flagcdn.com/h40/iq.png" },
    { value: "ie", label: "Ireland", image: "https://flagcdn.com/h40/ie.png" },
    { value: "im", label: "Isle of Man", image: "https://flagcdn.com/h40/im.png" },
    { value: "il", label: "Israel", image: "https://flagcdn.com/h40/il.png" },
    { value: "it", label: "Italy", image: "https://flagcdn.com/h40/it.png" },
    { value: "jm", label: "Jamaica", image: "https://flagcdn.com/h40/jm.png" },
    { value: "jp", label: "Japan", image: "https://flagcdn.com/h40/jp.png" },
    { value: "je", label: "Jersey", image: "https://flagcdn.com/h40/je.png" },
    { value: "jo", label: "Jordan", image: "https://flagcdn.com/h40/jo.png" },
    { value: "kz", label: "Kazakhstan", image: "https://flagcdn.com/h40/kz.png" },
    { value: "ke", label: "Kenya", image: "https://flagcdn.com/h40/ke.png" },
    { value: "ki", label: "Kiribati", image: "https://flagcdn.com/h40/ki.png" },
    { value: "xk", label: "Kosovo", image: "https://flagcdn.com/h40/xk.png" },
    { value: "kw", label: "Kuwait", image: "https://flagcdn.com/h40/kw.png" },
    { value: "kg", label: "Kyrgyzstan", image: "https://flagcdn.com/h40/kg.png" },
    { value: "lv", label: "Latvia", image: "https://flagcdn.com/h40/lv.png" },
    { value: "lb", label: "Lebanon", image: "https://flagcdn.com/h40/lb.png" },
    { value: "ls", label: "Lesotho", image: "https://flagcdn.com/h40/ls.png" },
    { value: "lr", label: "Liberia", image: "https://flagcdn.com/h40/lr.png" },
    { value: "ly", label: "Libya", image: "https://flagcdn.com/h40/ly.png" },
    { value: "li", label: "Liechtenstein", image: "https://flagcdn.com/h40/li.png" },
    { value: "lt", label: "Lithuania", image: "https://flagcdn.com/h40/lt.png" },
    { value: "lu", label: "Luxembourg", image: "https://flagcdn.com/h40/lu.png" },
    { value: "mo", label: "Macau", image: "https://flagcdn.com/h40/mo.png" },
    { value: "mg", label: "Madagascar", image: "https://flagcdn.com/h40/mg.png" },
    { value: "mw", label: "Malawi", image: "https://flagcdn.com/h40/mw.png" },
    { value: "my", label: "Malaysia", image: "https://flagcdn.com/h40/my.png" },
    { value: "mv", label: "Maldives", image: "https://flagcdn.com/h40/mv.png" },
    { value: "mt", label: "Malta", image: "https://flagcdn.com/h40/mt.png" },
    { value: "mh", label: "Marshall Islands", image: "https://flagcdn.com/h40/mh.png" },
    { value: "mq", label: "Martinique", image: "https://flagcdn.com/h40/mq.png" },
    { value: "mr", label: "Mauritania", image: "https://flagcdn.com/h40/mr.png" },
    { value: "mu", label: "Mauritius", image: "https://flagcdn.com/h40/mu.png" },
    { value: "yt", label: "Mayotte", image: "https://flagcdn.com/h40/yt.png" },
    { value: "mx", label: "Mexico", image: "https://flagcdn.com/h40/mx.png" },
    { value: "fm", label: "Micronesia", image: "https://flagcdn.com/h40/fm.png" },
    { value: "md", label: "Moldova", image: "https://flagcdn.com/h40/md.png" },
    { value: "mc", label: "Monaco", image: "https://flagcdn.com/h40/mc.png" },
    { value: "mn", label: "Mongolia", image: "https://flagcdn.com/h40/mn.png" },
    { value: "me", label: "Montenegro", image: "https://flagcdn.com/h40/me.png" },
    { value: "ms", label: "Montserrat", image: "https://flagcdn.com/h40/ms.png" },
    { value: "ma", label: "Morocco", image: "https://flagcdn.com/h40/ma.png" },
    { value: "mz", label: "Mozambique", image: "https://flagcdn.com/h40/mz.png" },
    { value: "mm", label: "Myanmar", image: "https://flagcdn.com/h40/mm.png" },
    { value: "na", label: "Namibia", image: "https://flagcdn.com/h40/na.png" },
    { value: "nr", label: "Nauru", image: "https://flagcdn.com/h40/nr.png" },
    { value: "np", label: "Nepal", image: "https://flagcdn.com/h40/np.png" },
    { value: "nl", label: "Netherlands", image: "https://flagcdn.com/h40/nl.png" },
    { value: "nc", label: "New Caledonia", image: "https://flagcdn.com/h40/nc.png" },
    { value: "nz", label: "New Zealand", image: "https://flagcdn.com/h40/nz.png" },
    { value: "ni", label: "Nicaragua", image: "https://flagcdn.com/h40/ni.png" },
    { value: "ne", label: "Niger", image: "https://flagcdn.com/h40/ne.png" },
    { value: "ng", label: "Nigeria", image: "https://flagcdn.com/h40/ng.png" },
    { value: "kp", label: "North Korea", image: "https://flagcdn.com/h40/kp.png" },
    { value: "mk", label: "North Macedonia", image: "https://flagcdn.com/h40/mk.png" },
    { value: "mp", label: "Northern Mariana Islands", image: "https://flagcdn.com/h40/mp.png" },
    { value: "no", label: "Norway", image: "https://flagcdn.com/h40/no.png" },
    { value: "pk", label: "Pakistan", image: "https://flagcdn.com/h40/pk.png" },
    { value: "pw", label: "Palau", image: "https://flagcdn.com/h40/pw.png" },
    { value: "pa", label: "Panama", image: "https://flagcdn.com/h40/pa.png" },
    { value: "pg", label: "Papua New Guinea", image: "https://flagcdn.com/h40/pg.png" },
    { value: "py", label: "Paraguay", image: "https://flagcdn.com/h40/py.png" },
    { value: "pe", label: "Perú", image: "https://flagcdn.com/h40/pe.png" },
    { value: "ph", label: "Philippines", image: "https://flagcdn.com/h40/ph.png" },
    { value: "pl", label: "Poland", image: "https://flagcdn.com/h40/pl.png" },
    { value: "pt", label: "Portugal", image: "https://flagcdn.com/h40/pt.png" },
    { value: "pr", label: "Puerto Rico", image: "https://flagcdn.com/h40/pr.png" },
    { value: "qa", label: "Qatar", image: "https://flagcdn.com/h40/qa.png" },
    { value: "re", label: "Reunion", image: "https://flagcdn.com/h40/re.png" },
    { value: "ro", label: "Romania", image: "https://flagcdn.com/h40/ro.png" },
    { value: "ru", label: "Russia", image: "https://flagcdn.com/h40/ru.png" },
    { value: "rw", label: "Rwanda", image: "https://flagcdn.com/h40/rw.png" },
    { value: "sh", label: "Saint Helena", image: "https://flagcdn.com/h40/sh.png" },
    { value: "kn", label: "Saint Kitts and Nevis", image: "https://flagcdn.com/h40/kn.png" },
    { value: "lc", label: "Saint Lucia", image: "https://flagcdn.com/h40/lc.png" },
    { value: "mf", label: "Saint Martin", image: "https://flagcdn.com/h40/mf.png" },
    { value: "pm", label: "Saint Pierre and Miquelon", image: "https://flagcdn.com/h40/pm.png" },
    { value: "vc", label: "Saint Vincent and the Grenadines", image: "https://flagcdn.com/h40/vc.png" },
    { value: "ws", label: "Samoa", image: "https://flagcdn.com/h40/ws.png" },
    { value: "sm", label: "San Marino", image: "https://flagcdn.com/h40/sm.png" },
    { value: "st", label: "Sao Tome and Principe", image: "https://flagcdn.com/h40/st.png" },
    { value: "sa", label: "Saudi Arabia", image: "https://flagcdn.com/h40/sa.png" },
    { value: "sn", label: "Senegal", image: "https://flagcdn.com/h40/sn.png" },
    { value: "rs", label: "Serbia", image: "https://flagcdn.com/h40/rs.png" },
    { value: "sc", label: "Seychelles", image: "https://flagcdn.com/h40/sc.png" },
    { value: "sl", label: "Sierra Leone", image: "https://flagcdn.com/h40/sl.png" },
    { value: "sg", label: "Singapore", image: "https://flagcdn.com/h40/sg.png" },
    { value: "sx", label: "Sint Maarten", image: "https://flagcdn.com/h40/sx.png" },
    { value: "sk", label: "Slovakia", image: "https://flagcdn.com/h40/sk.png" },
    { value: "si", label: "Slovenia", image: "https://flagcdn.com/h40/si.png" },
    { value: "sb", label: "Solomon Islands", image: "https://flagcdn.com/h40/sb.png" },
    { value: "so", label: "Somalia", image: "https://flagcdn.com/h40/so.png" },
    { value: "za", label: "South Africa", image: "https://flagcdn.com/h40/za.png" },
    { value: "kr", label: "South Korea", image: "https://flagcdn.com/h40/kr.png" },
    { value: "ss", label: "South Sudan", image: "https://flagcdn.com/h40/ss.png" },
    { value: "es", label: "Spain", image: "https://flagcdn.com/h40/es.png" },
    { value: "lk", label: "Sri Lanka", image: "https://flagcdn.com/h40/lk.png" },
    { value: "bl", label: "St. Barts", image: "https://flagcdn.com/h40/bl.png" },
    { value: "sd", label: "Sudan", image: "https://flagcdn.com/h40/sd.png" },
    { value: "sr", label: "Suriname", image: "https://flagcdn.com/h40/sr.png" },
    { value: "se", label: "Sweden", image: "https://flagcdn.com/h40/se.png" },
    { value: "ch", label: "Switzerland", image: "https://flagcdn.com/h40/ch.png" },
    { value: "sy", label: "Syria", image: "https://flagcdn.com/h40/sy.png" },
    { value: "tw", label: "Taiwan", image: "https://flagcdn.com/h40/tw.png" },
    { value: "tj", label: "Tajikistan", image: "https://flagcdn.com/h40/tj.png" },
    { value: "tz", label: "Tanzania", image: "https://flagcdn.com/h40/tz.png" },
    { value: "th", label: "Thailand", image: "https://flagcdn.com/h40/th.png" },
    { value: "bs", label: "The Bahamas", image: "https://flagcdn.com/h40/bs.png" },
    { value: "to", label: "Tonga", image: "https://flagcdn.com/h40/to.png" },
    { value: "tt", label: "Trinidad and Tobago", image: "https://flagcdn.com/h40/tt.png" },
    { value: "tn", label: "Tunisia", image: "https://flagcdn.com/h40/tn.png" },
    { value: "tr", label: "Turkey", image: "https://flagcdn.com/h40/tr.png" },
    { value: "tm", label: "Turkmenistan", image: "https://flagcdn.com/h40/tm.png" },
    { value: "tc", label: "Turks and Caicos Islands", image: "https://flagcdn.com/h40/tc.png" },
    { value: "tv", label: "Tuvalu", image: "https://flagcdn.com/h40/tv.png" },
    { value: "vi", label: "US Virgin Islands", image: "https://flagcdn.com/h40/vi.png" },
    { value: "ug", label: "Uganda", image: "https://flagcdn.com/h40/ug.png" },
    { value: "ua", label: "Ukraine", image: "https://flagcdn.com/h40/ua.png" },
    { value: "ae", label: "United Arab Emirates", image: "https://flagcdn.com/h40/ae.png" },
    { value: "gb", label: "United Kingdom", image: "https://flagcdn.com/h40/gb.png" },
    { value: "us", label: "United States", image: "https://flagcdn.com/h40/us.png" },
    { value: "uy", label: "Uruguay", image: "https://flagcdn.com/h40/uy.png" },
    { value: "uz", label: "Uzbekistan", image: "https://flagcdn.com/h40/uz.png" },
    { value: "vu", label: "Vanuatu", image: "https://flagcdn.com/h40/vu.png" },
    { value: "ve", label: "Venezuela", image: "https://flagcdn.com/h40/ve.png" },
    { value: "vn", label: "Vietnam", image: "https://flagcdn.com/h40/vn.png" },
    { value: "wf", label: "Wallis and Futuna", image: "https://flagcdn.com/h40/wf.png" },
    { value: "ye", label: "Yemen", image: "https://flagcdn.com/h40/ye.png" },
    { value: "zm", label: "Zambia", image: "https://flagcdn.com/h40/zm.png" },
    { value: "zw", label: "Zimbabwe", image: "https://flagcdn.com/h40/zw.png" },
    { value: "sz", label: "eSwatini", image: "https://flagcdn.com/h40/sz.png" },
];

const Item = ({item, isSelected, onSelect, onUnselect, className = ""}) => {
    return (
        <div 
            onClick={isSelected ? onUnselect : onSelect} 
            className={`
                transition-all 
                bg-gray-50 
                hover:bg-gray-100 
                text-tertiary-700 
                dark:bg-gray-700 
                dark:text-gray-50 
                hover:dark:bg-gray-700 
                cursor-pointer 
                inline-block 
                p-4 pt-3 
                px-5 
                rounded-2xl 
                !text-sm
                transition-all 
                flex
                items-center
                gap-2.5
                relative 
                ${isSelected && `
                    bg-gradient-secondary
                    !text-white
                    !font-semibold
                `}
                ${className}
            `}
        >
            {isSelected && <ParticleBackground settings={particleBackgroundSettingsButton} className="absolute" />}
            <div className="flex-1 flex flex-col gap-0.5">
                <span className="font-bold text-base">{item?.name}</span>
                <span className="dark:text-gray-300 text-xs">{item?.description}</span>
            </div>
            {isSelected 
                ? <HiCheckCircle className="shrink-0 text-2xl text-white" />
                : <HiOutlineCheckCircle className="shrink-0 text-2xl opacity-[0.2]" />
            }
        </div>
    );
}

const CalendarTemplate = ({
    generatePostsFromContexts,
    home_item = undefined,
    home_country_iso_code = undefined,
    config,
    setConfig
}) => {

    const maxSelection = usePostGenerationQuantity();

    const { getByQueryChat } = useContext(AIContext);
    const { company } = useContext(CompanyContext);
    const [ filteredData, setFilteredData ] = useState();
    const [ data, setData ] = useState();
    const [ selected, setSelected ] = useState([]);
    const [ isLoading, setIsLoading ] = useState(false);
    const [ loadingSmartFilter, setLoadingSmartFilter ] = useState(false);
    const [ smartFilter, setSmartFilter ] = useState();
    const [ selectedCountryCode, setSelectedCountryCode ] = useState(localStorage.getItem(`selectedCountryCode${company?.id}`) || company?.country_iso_code || "us");
    const { getHolidays } = useHolidays();
    const isInitialMount = useRef(true);
    const locale = useSelector((state) => state.locale.currentLang);
    const { t } = useTranslation();
    let todayDaySetted = false;
    const { whitelabel } = useWhitelabel();
    
    const get = async () => {
        setIsLoading(true);
        getHolidays(selectedCountryCode).then((holidays) => {
            setData(holidays);
        }).finally(() => {
            setIsLoading(false);
        });
    }

    const onSelect = (item) => {
        if (selected?.length >= maxSelection) {
            toast.push(<Notification title={`You can't select more than ${maxSelection} events at once.`} type="warning" />);
            return;
        }
        setSelected([item, ...selected]);
    }

    const onUnselect = (item) => {
        setSelected(selected.filter(e => JSON.stringify(e) != JSON.stringify(item)))
    }

    const handleOnSubmit = async () => {
        const contexts = selected.map((item) => `Event: ${item.name}.\nDescription: ${item.description}`)
        generatePostsFromContexts(contexts);
    }

    const goTo = (id) => {
        const section = document.getElementById(id);
        if (section) {
            section.scrollIntoView({behavior: 'smooth', block: 'start' });
        }
    }

    const goToToday = () => {
        const section = document.getElementById(`${new Date().toISOString().split("T")[0]}`);
        if (section) {
            section.scrollIntoView({behavior: 'smooth', block: 'start' });
        }
    }

    const handleSmartFilter = () => {
        if (data?.months?.length) {
            setLoadingSmartFilter(true);
            const events = data?.months?.map(month => month?.days?.map(day => day?.events?.map(event => event?.name))).flat().flat().flat();
            getByQueryChat(`
                Given the following holidays:
                ${events.map((e,i) => `${i}. ${e}`).join(`\n`)}

                List only the holidays that may be relevant for ${company?.name} and the most important ones. Keep the list numbers. Maximum of 20 holidays.
                Consider that ${company?.name} is looking at ${selectedCountryCode?.toUpperCase()} holidays.
                Answer only with the required list. No explanations. No preamble. 
            `).then((response) => {
                localStorage.setItem(`holidaysSmartFilter${company?.id}`, response);
                setSmartFilter(response);
            }).finally(() => {
                setLoadingSmartFilter(false);
            })
        }
    }

    const handleRemoveSmartFilter = () => {
        localStorage.removeItem(`holidaysSmartFilter${company?.id}`);
        setSmartFilter(undefined);
        get();
    }

    useEffect(() => {
        if (selectedCountryCode) {
            get();
        }
    }, [selectedCountryCode, company?.id]);

    useEffect(() => {
        if (data) {
            localStorage.setItem(`selectedCountryCode${company?.id}`, selectedCountryCode);
            if (isInitialMount.current) {
                isInitialMount.current = false;
                if (home_item) {
                    let home_item_date = new Date(home_item?.date?.iso);
                    home_item_date.setFullYear(new Date().getFullYear());
                    home_item_date = home_item_date.toISOString().split("T")[0] + " 12:00:00";
                    goTo(home_item_date);
                } else {
                    goToToday();
                }
            }
        }
    }, [data]);

    // useEffect(() => {
    //     if (!data) {
    //         if (localStorage.getItem(`selectedCountryCode${company?.id}`)) {
    //             setSelectedCountryCode(localStorage.getItem(`selectedCountryCode${company?.id}`));
    //         }
    //     }
    // }, []);

    useEffect(() => {
        if (home_item && home_country_iso_code) {
            onSelect(home_item);
            setSelectedCountryCode(home_country_iso_code);
        }
    }, []);

    useEffect(() => {
        setSmartFilter(
            localStorage.getItem(`holidaysSmartFilter${company?.id}`) || undefined
        );
    }, [company?.id]);

    useEffect(() => {
        if (!!smartFilter) {
            let _data = !!data ? {...data} : {};
            _data.months = _data.months?.map(month => {
                let _month = month;
                month.days = month?.days?.map(day => {
                    let _day = day;
                    _day.events = day?.events?.filter(event => 
                        !smartFilter || smartFilter?.includes(event?.name)
                    );
                    return !!_day.events.length ? _day : undefined;
                })
                month.days = month.days.filter(day => !!day);
                return _month;
            })
            _data.months = _data.months?.filter(month => !!month?.days?.length);
            setFilteredData(_data);
        } else {
            setFilteredData(data);
        }
    }, [data, smartFilter, company?.id]);

    return (
        <div className="w-full h-full flex items-start p-4 gap-4">
            <ConfigPanel 
                selected={selected}
                onSubmit={handleOnSubmit}
                config={config}
                setConfig={setConfig}
            />
            <div className="flex-1 flex flex-col lg:flex-row gap-2 w-full h-full overflow-y-auto">
                <div className="flex-1 flex flex-col lg:flex-row gap-2 w-full overflow-y-auto">
                    <div className="overflow-y-auto p-1 shrink-0 flex-1">
                        <div className='p-0 relative pb-4 flex items-end gap-4 flex-col'> 
                            <Dropdown
                                placement="bottom-start"
                                parentClassName={`w-full flex-1 w-full`}
                                menuClass="w-auto max-h-[300px] overflow-y-auto"
                                renderTitle={
                                    <Button className={`w-full flex gap-2 justify-between items-center !py-4 !px-6 !h-auto`}>
                                        <div className="flex items-center gap-2">
                                            <span className="!font-normal">Country:</span>
                                            <img className="h-3 w-4 object-fit object-cover" src={`https://flagcdn.com/h40/${countryOptions.find((option) => option.value == selectedCountryCode).value}.png`} />
                                            {countryOptions.find((option) => option.value.toLowerCase() == selectedCountryCode.toLowerCase()).label}
                                        </div>
                                        <HiChevronDown />
                                    </Button>
                                }
                            >
                                {countryOptions.map((country, key) => (
                                    <Dropdown.Item key={key} onClick={() => setSelectedCountryCode(country.value)} className="flex items-center gap-2 py-2 px-4">
                                        <img className="h-3 w-4 object-fit object-cover" src={`https://flagcdn.com/h40/${country.value}.png`} />
                                        <span>{country.label}</span>
                                    </Dropdown.Item>
                                ))}
                            </Dropdown>

                            {filteredData && filteredData?.months && filteredData?.months?.length > 0 && 
                                <div className="w-full flex flex-wrap gap-4 items-center">
                                    <div className="flex-1 flex flex-wrap gap-2">
                                        <Button 
                                            size="xs"
                                            onClick={goToToday} 
                                        >
                                            Today
                                        </Button>
                                        {[1,2,3,4,5,6,7,8,9,10,11,12].map((number) => (
                                            <Button 
                                                size="xs"
                                                onClick={() => goTo(`${`month-${new Date(`2023-${("0" + number).slice(-2)}-01 12:00:00`).toLocaleString(locale, { month: "long" })}`}`)} 
                                            >
                                                {`${new Date(`2023-${("0" + number).slice(-2)}-01 12:00:00`).toLocaleString(locale, { month: "long" })}`}
                                            </Button>
                                        ))}
                                    </div>
                                </div>
                            }
                        </div>

                        <div className="flex flex-col lg:flex-row items-center gap-4 my-2">
                            {!!smartFilter
                                ? <Button 
                                    variant="twoTone"
                                    color="gray"
                                    icon={<TbX />}
                                    onClick={() => handleRemoveSmartFilter()}
                                >
                                    Remove Smart Filters
                                </Button> 
                                : <Button 
                                    variant="ai"
                                    icon={<BsStars />}
                                    onClick={() => handleSmartFilter()}
                                    loading={loadingSmartFilter}
                                >
                                    Holiday Smart Filter
                                </Button>
                            }
                            <div className="text-center lg:text-left">
                                Use AI to filter the relevant holidays for {company?.name}.
                                <br />
                                {whitelabel?.name} will use your company information to show you only the relevant holidays.
                            </div>
                        </div>
                        
                        <div className="h-fit pb-8 flex flex-col gap-8 mt-6 relative">
                            <Tooltip title="Go to top" placement='left' wrapperClass='fixed bottom-12 lg:bottom-12'>
                                <Button onClick={() => goTo(`month-${new Date("2023-01-01 12:00:00").toLocaleString(locale, { month: "long" })}`)} className="shadow-lg" variant="twoTone" shape="circle" size="md" icon={<HiOutlineArrowUp />} />
                            </Tooltip>
                            {!isLoading && filteredData && filteredData?.months && filteredData?.months?.length ? 
                                filteredData?.months?.map((month, key) => (
                                    <div className="flex flex-col gap-4" key={key}>
                                        <h5 id={`month-${new Date(`2023-${("0" + month?.number).slice(-2)}-01 12:00:00`).toLocaleString(locale, { month: "long" })}`}>
                                            {new Date(`2023-${("0" + month?.number).slice(-2)}-01 12:00:00`).toLocaleString(locale, { month: "long" })}
                                        </h5>
                                        <Timeline>
                                            {month?.days?.map((day, key) => { 
                                                const fullDate = `${new Date().getFullYear()}-${("0" + (month?.number)).slice(-2)}-${("0" + day?.number).slice(-2)} 12:00:00`;
                                                const fullDateObj = new Date(fullDate);
                                                let addTodayDateAnchor = false;
                                                if (fullDateObj >= new Date() && !todayDaySetted) {
                                                    addTodayDateAnchor = true;
                                                    todayDaySetted = true;
                                                }
                                                return (
                                                    <Timeline.Item
                                                        key={key}
                                                        media={
                                                            <div 
                                                                className="flex flex-col items-center justify-center !w-12"
                                                                id={fullDate}
                                                            >
                                                                <h2 className="mega-title text-2xl">{("0" + day?.number).slice(-2)}</h2>
                                                                <p className="text-center text-lg -mt-1">{fullDateObj.toLocaleString(locale, { month: "short" })}</p>
                                                                {/* <p className="text-center text-lg -mt-1">{new Date(fullDate).toString().split(' ')[0]}</p> */}
                                                            </div>
                                                        }
                                                    >
                                                        {addTodayDateAnchor && <div className="invisible h-0 w-0" id={`${new Date().toISOString().split("T")[0]}`}></div>}
                                                        {day?.events?.map((item, key) => (
                                                            <Item 
                                                                key={key}
                                                                item={item}
                                                                isSelected={selected.filter(e => JSON.stringify(e) == JSON.stringify(item))?.length > 0}
                                                                onSelect={() => onSelect(item)}
                                                                onUnselect={() => onUnselect(item)}
                                                                className="mb-2"
                                                            />
                                                        ))}
                                                    </Timeline.Item>
                                                )
                                            })}
                                        </Timeline>
                                    </div>
                                ))
                            : 
                                <>
                                    {isLoading && <div className="my-4"><Loading type={'element'} /></div> }
                                </>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default CalendarTemplate;